import { PaddedDesktopContainer } from 'ui/DesktopContainer';
import { colors } from 'ui/constants';
import { media } from 'style-utils';
import styled from 'styled-components';
import { isMobile } from 'utils/utils';

export const height = {
  mobile: 100,
  desktop: 85,
};

export default styled(PaddedDesktopContainer)`
  background-color: ${colors.offwhite};
  height: ${height.mobile}px;

  padding: ${isMobile ? `0` : `0 15px` };
  padding-right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${media.desktop`
    height: ${height.desktop}px;
    width: content-width;
  `}
`;

